// extracted by mini-css-extract-plugin
export default {"status_chart":"AppStatusChart_status_chart_fAdk8","status_chart_wrapper":"AppStatusChart_status_chart_wrapper_ssIaA"};